import { axiosCore } from './http-core-service';
import { ConnectionStatsDto } from './dtos/connection-stats.dto';

/**
 * Récupération des statistiques de connexion (compteur + tendance).
 * @param days nombre de jours de tendance à récupérer
 */
export const getConnectionStats = async (days = 30): Promise<ConnectionStatsDto> => {
    const response = await axiosCore.get(`/api/admin/connections/stats?days=${days}`);
    return response.data;
};
